module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"selected_kpis":"https://www.flow-solutions.com/get-started?hsCtaTracking=fa2aa6d4-26e4-46d2-9ad4-3b22ae12c719%7C2f9598a1-dfe0-4a11-bed4-b59c2f6e1d4e","custom_range":"カスタム範囲","compare_period":"比較期間","compare_with":"比較日","previous_period":"前期間"}}')
  delete Component.options._Ctor
}
